import { createSlice } from "@reduxjs/toolkit";

export const diagnosticdata = createSlice({
    name: 'diagnosticdata',

    initialState: {
        gatewayList: [],
        deviceList: []
    },

    reducers: {
        updategatewaylist: (state, list) => {
            state.gatewayList = list.payload
        },
        updatedevicelist: (state, list) => {
            state.deviceList = list.payload
        }
    }
})

export const { updategatewaylist, updatedevicelist } = diagnosticdata.actions
export default diagnosticdata.reducer